export const HEADER_ACTION_BUTTON_CLASS =
    "h-8 shrink-0 gap-1.5 bg-muted px-3 text-sm font-medium text-muted-foreground hover:bg-muted-foreground hover:text-white";

export const HEADER_LAST_CALL_POPOVER_CLASS = "w-[380px] max-h-[min(36rem,80vh)] overflow-y-auto p-3";

export const HEADER_DIALER_POPOVER_CLASS = "w-[320px] p-3";
